import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { NgZone} from '@angular/core';
import { Roles } from 'src/app/interfaces/interfaces';
import { BehaviorSubject, Subscription } from 'rxjs';




@Component({
  selector: 'app-seleccion-rol',
  templateUrl: './seleccion-rol.component.html',
  styleUrls: ['./seleccion-rol.component.css']
})
export class SeleccionRolComponent implements OnInit {
  rolesUsuario: number[] = [0];
  roles: Roles[]=[];
  opcionSeleccionado:number;
  verSeleccion:number;
  iniciativas:boolean=false;
  idRol:Subscription;
  logueando:boolean=false;


  constructor(private authService: AuthService,
    private router: Router,
    private zone: NgZone) { }

  ngOnInit(): void {
    this.roles=this.authService.roles;
  }

  capturar() 
  {
    // Pasamos el valor seleccionado a la variable verSeleccion
    this.verSeleccion = this.opcionSeleccionado;
  }


  ingresarPortal()
  {
    this.logueando=true;
     this.authService.nombreRol$.emit(this.verSeleccion);
     this.authService.emiteRolSeleccionado(this.verSeleccion);
     this.logueando=false;
    
  }

}
